export default __webpack_public_path__ + "static/media/31.3ef469a7.svg";